module.exports = __webpack_public_path__ + "static/media/bar-chart.55b27d99.png";